import { Navigate } from "react-router-dom";
import { useAgentAuth } from "../context/AuthContext";

export default function AgentProtectedRoute({ children }) {
  const { agent, initializing } = useAgentAuth();

  if (initializing) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-[#0b1220]" data-testid="agent-auth-loading">
        <div className="h-10 w-10 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!agent) return <Navigate to="/agent/login" replace />;
  return children;
}
